import { useEffect, useState } from "react";
import apiShow from "../../apis/api.show";
import "./PaymentTicket.scss";

function PaymentTicket(props) {
  const [ticket, setTicket] = useState(props.ticket ? props.ticket : {});
  const [shows, setShows] = useState([]);
  const [hideShow, setHideShow] = useState(true);

  useEffect(() => {
    const getData = async () => {
      const res = await apiShow.getShowByTicketId(ticket.ticket_id);
      setShows(res.elements);
    };
    getData();
  }, []);
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const handleClickShow = () => {
    setHideShow(!hideShow);
  };
  return (
    <>
          {ticket ? (
            <>
              <h3> Suất chiếu</h3>
              <p>
                {ticket.hour} - Ngày {ticket.date.split("T")[0]}
              </p>
              <h3>Thông tin vé</h3>
              <div className="ticket-info">
                <p>
                  {ticket.ticket_count} x {ticket.ticket_name}
                </p>
                <p>{numberWithCommas(ticket.total_price)} VND</p>
              </div>
              <button
              onClick={() => handleClickShow()}
              >Áp dụng cho các show</button>
              {
                hideShow? (<>
                </>) :(<>
                  <div className="show-info">
                <div>
                  {shows.map((item) => (
                    <div className="show-info-row">
                      <img src={item.show_image} />
                      <p>{item.show_name}</p>
                    </div>
                  ))}
                </div>
              </div>
                </>)
              }
            </>
          ) : (
            <></>
          )}
    </>
  );
}
export default PaymentTicket;
